// extracted by mini-css-extract-plugin
export default {"input":"checkboxInput_input__mWoIM","error":"checkboxInput_error__iRIND","errorMsg":"checkboxInput_errorMsg__eb9vD"};